module.exports = __webpack_public_path__ + "img/Traditional-Pricing-Grid-2024-2.a697dc6f.jpg";